import { isSameOrBefore } from './isSameOrBefore';

export const getEarliestDate = (dateStrings: string[]): string => {
  if (dateStrings.length === 1) {
    return dateStrings[0];
  }
  let earliest = dateStrings[0];
  dateStrings.slice(1).forEach(dateString => {
    if (isSameOrBefore(dateString, earliest)) {
      earliest = dateString;
    }
  });
  return earliest;
};
